/**
 * Created by vwiny on 10/30/2017.
 */
import { Injectable } from '@angular/core';
import { SohoSwapListService } from 'ids-enterprise-ng';
import { of as observableOf, Observable } from 'rxjs';

@Injectable()
export class ReportPersonalizationSwapListService extends SohoSwapListService {
  private options: SohoSwapListOptions = {};
  private availableToolbarActions: SohoSwapListItem[] = [];
  private selectedDemoItems: SohoSwapListItem[] = [];
  private additionalDemoItems: SohoSwapListItem[] = [];

  getData(): Observable<SohoSwapListOptions> {
    console.log(this.options.available);
    return observableOf(this.options);
  }

  constructor() {
    super();
    this.init();
  }

  updateItems(actions: Array<LMActionSpec>) {
    for (let i = 0; i < actions.length; i++) {
      const action = actions[i];
      this.availableToolbarActions.push({ id: i, value: action.name, text: action.name });
    }
  }
  init() {
    this.options.available = this.availableToolbarActions;
  }
}
